import { render, staticRenderFns } from "./UpdateForm.vue?vue&type=template&id=fd1af2a2&"
import script from "./UpdateForm.vue?vue&type=script&lang=js&"
export * from "./UpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports